import { ReactNode } from "react";

interface HighlightCardProps {

    title: string;

    description: string;

    icon?: ReactNode;
}

export function HighlightCard({
    title,
    description,
    icon,
}: HighlightCardProps) {
    return (

        <div className="rounded-3xl border border-border bg-card p-7">

            {icon && (

                <div className="mb-5">

                    {icon}

                </div>

            )}

            <h3 className="text-xl font-semibold">

                {title}

            </h3>

            <p className="mt-3 leading-7 text-muted-foreground">

                {description}

            </p>

        </div>

    );
}